import Cookies from 'js-cookie';
import ten from '../img/character/ten.png';
import tenwebp from '../img/character/ten.webp';
import leii from '../img/character/leii.png';
import leiiwebp from '../img/character/leii.webp';
import arche from '../img/character/arche.png';
import archewebp from '../img/character/arche.webp';
import chica from '../img/character/chica.png';
import chicawebp from '../img/character/chica.webp';
import emero from '../img/character/emero.png';
import emerowebp from '../img/character/emero.webp';
import anzar from '../img/character/anzar.png';
import anzarwebp from '../img/character/anzar.webp';
import nares from '../img/character/nares.png';
import nareswebp from '../img/character/nares.webp';
import lookie_loo from '../img/character/lookie_loo.png';
import lookie_loowebp from '../img/character/lookie_loo.webp';

const characterImages = {
  ten: {
    image: 'img/character/ten.png',
    image_webp: 'img/character/ten.webp',
    thumb: 'img/character/ten_thumb.png',
    thumb_webp: 'img/character/ten_thumb.webp',
  },
  leii: {
    image: 'img/character/leii.png',
    image_webp: 'img/character/leii.webp',
    thumb: 'img/character/leii_thumb.png',
    thumb_webp: 'img/character/leii_thumb.webp',
  },
  arche: {
    image: 'img/character/arche.png',
    image_webp: 'img/character/arche.webp',
    thumb: 'img/character/arche_thumb.png',
    thumb_webp: 'img/character/arche_thumb.webp',
  },
  chica: {
    image: 'img/character/chica.png',
    image_webp: 'img/character/chica.webp',
    thumb: 'img/character/chica_thumb.png',
    thumb_webp: 'img/character/chica_thumb.webp',
  },
  emero: {
    image: 'img/character/emero.png',
    image_webp: 'img/character/emero.webp',
    thumb: 'img/character/emero_thumb.png',
    thumb_webp: 'img/character/emero_thumb.webp',
  },
  anzar: {
    image: 'img/character/anzar.png',
    image_webp: 'img/character/anzar.webp',
    thumb: 'img/character/anzar_thumb.png',
    thumb_webp: 'img/character/anzar_thumb.webp',
  },
  nares: {
    image: 'img/character/nares.png',
    image_webp: 'img/character/nares.webp',
    thumb: 'img/character/nares_thumb.png',
    thumb_webp: 'img/character/nares_thumb.webp',
  },
  lookie_loo: {
    image: 'img/character/lookie_loo.png',
    image_webp: 'img/character/lookie_loo.webp',
    thumb: 'img/character/lookie_loo_thumb.png',
    thumb_webp: 'img/character/lookie_loo_thumb.webp',
  },
};

const characterLinks = {
  ten: {
    name: 'Ten',
    highlight: "Raised in Dentro's orphanage.",
    desc: 'When he was a child, he formed a playgroup known as the Dragons of Centvelt with Leii and Arche. Honest and bold, he prefers to act instead of sitting around thinking. Ten respects Anzar as a big-brother figure whom he hopes to surpass someday.',
  },
  leii: {
    name: 'Leii',
    highlight:
      'Raised in Dentro’s orphanage, and one of Ten’s best friends since childhood.',
    desc: 'He can lose his nerve at times, but he usually stays calm, makes rational decisions, and keeps an open mind. He tries his best to act gruff, a trait he adopted to hide his self-consciousness.',
  },
  arche: {
    name: 'Arche',
    highlight: 'Raised in Dentro’s orphanage.',
    desc: "She formed a playgroup known as the Dragons of Centvelt with Ten and Leii as kids. Friendly, cheerful, and sincere, she's best friends with Chica, someone she sees as a younger sister. Her physical health has been failing her as of late...",
  },
  chica: {
    name: 'Chica',
    highlight: "Ten's childhood friend.",
    desc: 'She is a Farmagia who is gentle and timid by nature. She prefers to avoid conflict, not wanting to see anyone get hurt. She looked up to Emero as a big-brother figure when she was a child.',
  },
  emero: {
    name: 'Emero',
    highlight: "Raised in Dentro's orphanage.",
    desc: 'He treated Chica like a younger sister when they were children. He went missing at a young age while protecting Chica from a fearsome monster.',
  },
  anzar: {
    name: 'Anzar',
    highlight: "Raised in Dentro's orphanage.",
    desc: "Older than Ten, he was like a big brother to him in childhood. As an adult, he's lauded as a natural Farmagia genius.",
  },
  nares: {
    name: 'Nares',
    highlight: 'The Oración general ruling over Avrion.',
    desc: 'She rebelled against Glaza to put an end to his oppressive rule. As a Farmagia, she outclasses Ten and his friends, capable of commanding throngs of monsters. As the most accomplished strategist among the Oración Seis, she is better at leading armies than waging battles solo.',
  },
  lookie_loo: {
    name: 'Lookie-Loo',
    highlight: "Ten's fairy partner and sidekick.",
    desc: 'He frequently uses eye references in his speech such as "eye-eye, captain" and "I spy with my big eye." He lacks the skills other fairies possess, which he has hang-ups about. Though still a juvenile fairy, his body is apparently too large to fit in a Fairy Den.',
  },
};

const images = [
  ten,
  tenwebp,
  leii,
  leiiwebp,
  arche,
  archewebp,
  chica,
  chicawebp,
  emero,
  emerowebp,
  anzar,
  anzarwebp,
  nares,
  nareswebp,
  lookie_loo,
  lookie_loowebp,
];

const preloadImage = src => {
  return new Promise((res, rej) => {
    const img = new Image();
    img.addEventListener('load', () => res(src));
    img.addEventListener('error', err => rej(err));
    img.src = src;
  });
};

Promise.all(images.map(preloadImage)).then(images => {
  return;
});

// character selection

let canIClickCharacter = true;

const showCorrectCharacter = character => {
  const name = document.querySelector('.characters__name');
  const highlight = document.querySelector('.characters__highlight');
  const desc = document.querySelector('.characters__desc');
  const image = document.querySelector('.characters__image');
  const content = document.querySelector('.characters__content');
  const isWebpAvailable = document.querySelector('html');
  if (isWebpAvailable.classList.contains('webp')) {
    document.querySelector('.characters__href').href =
      characterImages[character].image_webp;
  } else {
    document.querySelector('.characters__href').href =
      characterImages[character].image;
  }
  const fading = document.querySelectorAll(
    '.characters__content, .characters__image',
  );
  fading.forEach(item => {
    item.classList.add('animated__hide');
  });
  image.classList.remove('animated__fadeInUp');
  content.classList.remove('animated__fadeInLeft');

  let url = '';
  name.textContent = characterLinks[character].name;
  highlight.textContent = characterLinks[character].highlight;
  desc.innerHTML = characterLinks[character].desc;
  if (isWebpAvailable.classList.contains('webp')) {
    url = characterImages[character].image_webp;
  } else {
    url = characterImages[character].image;
  }
  url = `./${url}`;
  preloadImage(url)
    .then(src => {
      image.src = src;
      image.classList.add('animated__fadeInUp');
      content.classList.add('animated__fadeInLeft');
      fading.forEach(item => {
        item.classList.remove('animated__hide');
      });
      canIClickCharacter = true;
    })
    .catch(err => console.error(err));
};

const characters = document.querySelectorAll('.characters__thumb');

characters.forEach(character => {
  character.addEventListener('click', e => {
    e.preventDefault();
    if (
      canIClickCharacter &&
      !e.target.classList.contains('characters__active')
    ) {
      canIClickCharacter = false;
      document
        .querySelector('.characters__active')
        .classList.remove('characters__active');
      character.classList.add('characters__active');
      const characterSelected = character.dataset.character;
      showCorrectCharacter(characterSelected);
    }
  });
});

//on startup this will set up the characer section. Will use the current language, set the console cookie to Switch and then call for the correct character area to be shown. If changing to a different console, you need to set the gameConsole cookie here to a different console.
const isWebpAvailable = document.querySelector('html');

if (isWebpAvailable.classList.contains('webp')) {
  document.querySelector('.characters__image').src =
    characterImages['ten'].image_webp;
  document.querySelector('.characters__href').href =
    `./${characterImages['ten'].image_webp}`;
} else {
  document.querySelector('.characters__image').src =
    characterImages['ten'].image;
  document.querySelector('.characters__href').href =
    `./${characterImages['ten'].image}`;
}
